import { render } from "./cloudSpace.vue?vue&type=template&id=7fdfdf4a&scoped=true"
import script from "./cloudSpace.vue?vue&type=script&lang=js"
export * from "./cloudSpace.vue?vue&type=script&lang=js"

import "./cloudSpace.vue?vue&type=style&index=0&id=7fdfdf4a&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fdfdf4a"]])

export default __exports__